import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WrongLocationPageComponent } from './wrong-location-page.component';

const routes: Routes = [
  {
    path: '',
    component: WrongLocationPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WrongLocationPageRoutingModule {}
